/*
 * Tessuti - variant-aware product thumbnail strip.
 *
 * The product section renders every media item of the product into
 * .t-pd__thumbs, with no variant association at all, so switching colour left
 * the strip showing all the other colours' swatches. This narrows the strip to
 * the selected variant.
 *
 * "The variant's images" can only mean one thing on Shopify's data model:
 * a variant links to at most ONE media item (variant.featured_image), and the
 * rest of the media - the drape and detail shots - belong to the fabric, not to
 * a colourway. So the rule here is:
 *
 *     show the selected variant's own image, plus every image that no variant
 *     has claimed; hide only images claimed by a DIFFERENT variant.
 *
 * Almost the whole catalogue is single-variant with no variant image at all.
 * For those products nothing is claimed, nothing is hidden, and the strip
 * behaves exactly as before.
 *
 * This runs entirely off markup the section already emits - the variant JSON in
 * #t-pd-data-<section id> and the data-src on each thumb - so it needs no
 * change to sections/tessuti-product.liquid.
 */
(function () {
  'use strict';

  // The variant JSON gives a CDN src, the thumbs give a resized one. Reducing
  // both to the bare filename is what lets them be compared.
  function imageKey(url) {
    if (!url) return '';
    var clean = String(url).split('?')[0];
    var file = clean.substring(clean.lastIndexOf('/') + 1);
    // Strip Shopify's size suffix: foo_1100x.jpg / foo_200x200.jpg -> foo.jpg
    return file.replace(/_(\d+)?x(\d+)?(_crop_[a-z]+)?(?=\.[a-z0-9]+$)/i, '').toLowerCase();
  }

  function injectStyle() {
    if (document.getElementById('t-pd-vgal-style')) return;
    var st = document.createElement('style');
    st.id = 't-pd-vgal-style';
    // .t-pd__thumbs is display:flex, which beats the browser default for
    // [hidden], so these have to be explicit.
    st.textContent =
      '.t-pd__thumbs[hidden],.t-pd__thumb[hidden],.t-pd__arw[hidden]{display:none !important;}';
    document.head.appendChild(st);
  }

  function setup(root) {
    if (root.dataset.vgalReady === '1') return;

    var strip = root.querySelector('.t-pd__thumbs');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.t-pd__thumb'));
    if (!strip || thumbs.length < 2) return;

    var dataEl = root.parentNode.querySelector('script[id^="t-pd-data-"]') ||
                 document.querySelector('script[id^="t-pd-data-"]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var main = root.querySelector('.t-pd__main img');
    var idIn = root.querySelector('input[name="id"], select[name="id"]');

    // Which image belongs to which variant, and which images are claimed at all.
    var byVariant = {};
    var claimed = {};
    var anyClaimed = false;
    variants.forEach(function (v) {
      var key = v.featured_image ? imageKey(v.featured_image.src) : '';
      byVariant[String(v.id)] = key;
      if (key) { claimed[key] = true; anyClaimed = true; }
    });

    // Nothing to filter on - leave this product completely alone.
    if (!anyClaimed) { root.dataset.vgalReady = '1'; return; }

    injectStyle();

    var prev = root.querySelector('.t-pd__arw--prev');
    var next = root.querySelector('.t-pd__arw--next');

    function apply(variantId) {
      var mine = byVariant[String(variantId)] || '';
      var own = null;

      thumbs.forEach(function (t) {
        var key = imageKey(t.dataset.src);
        var keep = (mine && key === mine) || !claimed[key];
        t.hidden = !keep;
        if (mine && key === mine) own = t;
      });

      var visible = thumbs.filter(function (t) { return !t.hidden; });
      // Defensive: never leave the gallery empty.
      if (!visible.length) {
        thumbs.forEach(function (t) { t.hidden = false; });
        visible = thumbs.slice();
      }

      // One thumb is just a smaller copy of the main image - drop the whole
      // strip and the arrows rather than show it alone.
      var sparse = visible.length < 2;
      strip.hidden = sparse;
      if (prev) prev.hidden = sparse;
      if (next) next.hidden = sparse;

      var target = own ||
        visible.filter(function (t) { return t.classList.contains('is-active'); })[0] ||
        visible[0];
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      if (target) {
        target.classList.add('is-active');
        // The section's own variant handler already swaps the main image when
        // the variant has one, so only push a src when it did not.
        if (!own && main && target.dataset.src) main.src = target.dataset.src;
      }
    }

    // The section rebinds its own change handler on these inputs; listening on
    // the container lets both run without touching its code.
    root.addEventListener('change', function (e) {
      if (!e.target.closest('.t-pd__opt')) return;
      // Let the section's handler write the new variant id first.
      setTimeout(function () { apply(idIn ? idIn.value : ''); }, 0);
    });

    apply(idIn ? idIn.value : '');
    root.dataset.vgalReady = '1';
  }

  function init() {
    document.querySelectorAll('.t-pd').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', init);
})();
